export var AccessGroupEntityType;
(function (AccessGroupEntityType) {
    AccessGroupEntityType["network"] = "network";
    AccessGroupEntityType["post"] = "post";
    AccessGroupEntityType["space"] = "space";
})(AccessGroupEntityType || (AccessGroupEntityType = {}));
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["failed"] = "failed";
    ActionStatus["succeeded"] = "succeeded";
})(ActionStatus || (ActionStatus = {}));
export var AppCollaboratorType;
(function (AppCollaboratorType) {
    AppCollaboratorType["COLLABORATOR"] = "COLLABORATOR";
    AppCollaboratorType["OWNER"] = "OWNER";
})(AppCollaboratorType || (AppCollaboratorType = {}));
export var AppInstallationStatus;
(function (AppInstallationStatus) {
    AppInstallationStatus["DELETED"] = "DELETED";
    AppInstallationStatus["DISABLED"] = "DISABLED";
    AppInstallationStatus["ENABLED"] = "ENABLED";
})(AppInstallationStatus || (AppInstallationStatus = {}));
export var AppInteractionType;
(function (AppInteractionType) {
    AppInteractionType["Close"] = "Close";
    AppInteractionType["Data"] = "Data";
    AppInteractionType["OpenModal"] = "OpenModal";
    AppInteractionType["OpenToast"] = "OpenToast";
    AppInteractionType["Redirect"] = "Redirect";
    AppInteractionType["Reload"] = "Reload";
    AppInteractionType["Show"] = "Show";
})(AppInteractionType || (AppInteractionType = {}));
export var BadgeType;
(function (BadgeType) {
    BadgeType["Manual"] = "Manual";
    BadgeType["NewMember"] = "NewMember";
    BadgeType["Role"] = "Role";
    BadgeType["SuspendedMember"] = "SuspendedMember";
})(BadgeType || (BadgeType = {}));
export var CallbackAction;
(function (CallbackAction) {
    CallbackAction["Insert"] = "Insert";
    CallbackAction["Modal"] = "Modal";
    CallbackAction["None"] = "None";
    CallbackAction["Replace"] = "Replace";
})(CallbackAction || (CallbackAction = {}));
export var CollectionListOrderByEnum;
(function (CollectionListOrderByEnum) {
    CollectionListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    CollectionListOrderByEnum["CUSTOM_ORDERING_INDEX"] = "CUSTOM_ORDERING_INDEX";
    CollectionListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(CollectionListOrderByEnum || (CollectionListOrderByEnum = {}));
export var CustomCodePosition;
(function (CustomCodePosition) {
    CustomCodePosition["BODY"] = "BODY";
    CustomCodePosition["HEAD"] = "HEAD";
})(CustomCodePosition || (CustomCodePosition = {}));
export var CustomFieldPrivacyOptions;
(function (CustomFieldPrivacyOptions) {
    CustomFieldPrivacyOptions["ADMIN"] = "ADMIN";
    CustomFieldPrivacyOptions["OWN"] = "OWN";
})(CustomFieldPrivacyOptions || (CustomFieldPrivacyOptions = {}));
export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["array"] = "array";
    CustomFieldType["boolean"] = "boolean";
    CustomFieldType["date"] = "date";
    CustomFieldType["number"] = "number";
    CustomFieldType["object"] = "object";
    CustomFieldType["relation"] = "relation";
    CustomFieldType["richText"] = "richText";
    CustomFieldType["text"] = "text";
})(CustomFieldType || (CustomFieldType = {}));
export var CustomFieldValidators;
(function (CustomFieldValidators) {
    CustomFieldValidators["allOf"] = "allOf";
    CustomFieldValidators["anyOf"] = "anyOf";
    CustomFieldValidators["enum"] = "enum";
    CustomFieldValidators["exclusiveMaximum"] = "exclusiveMaximum";
    CustomFieldValidators["exclusiveMinimum"] = "exclusiveMinimum";
    CustomFieldValidators["format"] = "format";
    CustomFieldValidators["maxItems"] = "maxItems";
    CustomFieldValidators["maxLength"] = "maxLength";
    CustomFieldValidators["maxProperties"] = "maxProperties";
    CustomFieldValidators["maximum"] = "maximum";
    CustomFieldValidators["minItems"] = "minItems";
    CustomFieldValidators["minLength"] = "minLength";
    CustomFieldValidators["minProperties"] = "minProperties";
    CustomFieldValidators["minimum"] = "minimum";
    CustomFieldValidators["multipleOf"] = "multipleOf";
    CustomFieldValidators["not"] = "not";
    CustomFieldValidators["oneOf"] = "oneOf";
    CustomFieldValidators["pattern"] = "pattern";
    CustomFieldValidators["uniqueItems"] = "uniqueItems";
})(CustomFieldValidators || (CustomFieldValidators = {}));
export var CustomSsoType;
(function (CustomSsoType) {
    CustomSsoType["Saml"] = "Saml";
    CustomSsoType["oauth2"] = "oauth2";
})(CustomSsoType || (CustomSsoType = {}));
export var DateTypeOptions;
(function (DateTypeOptions) {
    DateTypeOptions["date"] = "date";
    DateTypeOptions["datetime"] = "datetime";
})(DateTypeOptions || (DateTypeOptions = {}));
export var DefaultSsoType;
(function (DefaultSsoType) {
    DefaultSsoType["Apple"] = "Apple";
    DefaultSsoType["Discord"] = "Discord";
    DefaultSsoType["Slack"] = "Slack";
    DefaultSsoType["Twitter"] = "Twitter";
    DefaultSsoType["facebook"] = "facebook";
    DefaultSsoType["google"] = "google";
    DefaultSsoType["linkedin"] = "linkedin";
})(DefaultSsoType || (DefaultSsoType = {}));
export var DynamicBlockSize;
(function (DynamicBlockSize) {
    DynamicBlockSize["full"] = "full";
    DynamicBlockSize["lg"] = "lg";
    DynamicBlockSize["md"] = "md";
    DynamicBlockSize["sm"] = "sm";
    DynamicBlockSize["xl"] = "xl";
})(DynamicBlockSize || (DynamicBlockSize = {}));
export var EmailStatus;
(function (EmailStatus) {
    EmailStatus["BLOCKED"] = "BLOCKED";
    EmailStatus["BOUNCED"] = "BOUNCED";
    EmailStatus["CREATED"] = "CREATED";
    EmailStatus["DEFERRED"] = "DEFERRED";
    EmailStatus["DELIVERED"] = "DELIVERED";
    EmailStatus["DROPPED"] = "DROPPED";
    EmailStatus["PROCESSED"] = "PROCESSED";
    EmailStatus["SENT"] = "SENT";
})(EmailStatus || (EmailStatus = {}));
export var EmailType;
(function (EmailType) {
    EmailType["AppNotification"] = "AppNotification";
    EmailType["CollaboratorInvitation"] = "CollaboratorInvitation";
    EmailType["EmailVerification"] = "EmailVerification";
    EmailType["ExportFinished"] = "ExportFinished";
    EmailType["MemberConfirmation"] = "MemberConfirmation";
    EmailType["MemberInvitation"] = "MemberInvitation";
    EmailType["Notification"] = "Notification";
    EmailType["ResetPassword"] = "ResetPassword";
    EmailType["Unknown"] = "Unknown";
})(EmailType || (EmailType = {}));
export var EventVerb;
(function (EventVerb) {
    EventVerb["ACCEPTED"] = "ACCEPTED";
    EventVerb["ADDED"] = "ADDED";
    EventVerb["BANNED"] = "BANNED";
    EventVerb["BLOCKED"] = "BLOCKED";
    EventVerb["CANCELED"] = "CANCELED";
    EventVerb["CLICKED"] = "CLICKED";
    EventVerb["CREATED"] = "CREATED";
    EventVerb["CUSTOM"] = "CUSTOM";
    EventVerb["DELETED"] = "DELETED";
    EventVerb["EXPIRED"] = "EXPIRED";
    EventVerb["FAILED"] = "FAILED";
    EventVerb["FOLLOWED"] = "FOLLOWED";
    EventVerb["HIDDEN"] = "HIDDEN";
    EventVerb["IMPRESSION"] = "IMPRESSION";
    EventVerb["INSTALLED"] = "INSTALLED";
    EventVerb["LOGGED_IN"] = "LOGGED_IN";
    EventVerb["NOT_ASSIGNED"] = "NOT_ASSIGNED";
    EventVerb["PERMITTED"] = "PERMITTED";
    EventVerb["PING"] = "PING";
    EventVerb["PINGED"] = "PINGED";
    EventVerb["PINNED"] = "PINNED";
    EventVerb["PUBLISHED"] = "PUBLISHED";
    EventVerb["REJECTED"] = "REJECTED";
    EventVerb["REMOVED"] = "REMOVED";
    EventVerb["REVOKED"] = "REVOKED";
    EventVerb["SUSPENDED"] = "SUSPENDED";
    EventVerb["UNBLOCKED"] = "UNBLOCKED";
    EventVerb["UNFOLLOWED"] = "UNFOLLOWED";
    EventVerb["UNHIDDEN"] = "UNHIDDEN";
    EventVerb["UNINSTALLED"] = "UNINSTALLED";
    EventVerb["UNPINNED"] = "UNPINNED";
    EventVerb["UNPUBLISHED"] = "UNPUBLISHED";
    EventVerb["UNSUSPENDED"] = "UNSUSPENDED";
    EventVerb["UNUSED"] = "UNUSED";
    EventVerb["UNVERIFIED"] = "UNVERIFIED";
    EventVerb["UPDATED"] = "UPDATED";
    EventVerb["USED"] = "USED";
    EventVerb["VERIFIED"] = "VERIFIED";
    EventVerb["VIEWED"] = "VIEWED";
})(EventVerb || (EventVerb = {}));
export var ExportListOrderByEnum;
(function (ExportListOrderByEnum) {
    ExportListOrderByEnum["CreatedAt"] = "CreatedAt";
    ExportListOrderByEnum["UpdatedAt"] = "UpdatedAt";
})(ExportListOrderByEnum || (ExportListOrderByEnum = {}));
export var ExportStatus;
(function (ExportStatus) {
    ExportStatus["Done"] = "Done";
    ExportStatus["Expired"] = "Expired";
    ExportStatus["Failed"] = "Failed";
    ExportStatus["InProgress"] = "InProgress";
    ExportStatus["Initialized"] = "Initialized";
})(ExportStatus || (ExportStatus = {}));
export var ExtraPropertyEntityType;
(function (ExtraPropertyEntityType) {
    ExtraPropertyEntityType["Member"] = "Member";
    ExtraPropertyEntityType["Network"] = "Network";
})(ExtraPropertyEntityType || (ExtraPropertyEntityType = {}));
export var Filtername;
(function (Filtername) {
    Filtername["and"] = "and";
    Filtername["leaf"] = "leaf";
    Filtername["or"] = "or";
})(Filtername || (Filtername = {}));
export var FlaggedType;
(function (FlaggedType) {
    FlaggedType["MEMBER"] = "MEMBER";
    FlaggedType["SYSTEM"] = "SYSTEM";
})(FlaggedType || (FlaggedType = {}));
export var HighlightedTagType;
(function (HighlightedTagType) {
    HighlightedTagType["SECTION"] = "SECTION";
    HighlightedTagType["TOPIC"] = "TOPIC";
})(HighlightedTagType || (HighlightedTagType = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["cancelled"] = "cancelled";
    InvoiceStatus["failed"] = "failed";
    InvoiceStatus["paid"] = "paid";
    InvoiceStatus["pending"] = "pending";
})(InvoiceStatus || (InvoiceStatus = {}));
export var MassActionRequestAction;
(function (MassActionRequestAction) {
    MassActionRequestAction["Accept"] = "Accept";
    MassActionRequestAction["AddToSpace"] = "AddToSpace";
    MassActionRequestAction["AssignBadge"] = "AssignBadge";
    MassActionRequestAction["Create"] = "Create";
    MassActionRequestAction["Delete"] = "Delete";
    MassActionRequestAction["Expire"] = "Expire";
    MassActionRequestAction["Flag"] = "Flag";
    MassActionRequestAction["Follow"] = "Follow";
    MassActionRequestAction["Hide"] = "Hide";
    MassActionRequestAction["Pin"] = "Pin";
    MassActionRequestAction["Publish"] = "Publish";
    MassActionRequestAction["Reject"] = "Reject";
    MassActionRequestAction["Resend"] = "Resend";
    MassActionRequestAction["Revoke"] = "Revoke";
    MassActionRequestAction["RevokeBadge"] = "RevokeBadge";
    MassActionRequestAction["Suspend"] = "Suspend";
    MassActionRequestAction["Unflag"] = "Unflag";
    MassActionRequestAction["Unfollow"] = "Unfollow";
    MassActionRequestAction["Unhide"] = "Unhide";
    MassActionRequestAction["Unpin"] = "Unpin";
    MassActionRequestAction["Update"] = "Update";
    MassActionRequestAction["Verify"] = "Verify";
})(MassActionRequestAction || (MassActionRequestAction = {}));
export var MassActionRequestContext;
(function (MassActionRequestContext) {
    MassActionRequestContext["Member"] = "Member";
    MassActionRequestContext["MemberInvitation"] = "MemberInvitation";
    MassActionRequestContext["ModerationItem"] = "ModerationItem";
    MassActionRequestContext["Post"] = "Post";
    MassActionRequestContext["Space"] = "Space";
    MassActionRequestContext["Tag"] = "Tag";
})(MassActionRequestContext || (MassActionRequestContext = {}));
export var MassActionRequestStatus;
(function (MassActionRequestStatus) {
    MassActionRequestStatus["Done"] = "Done";
    MassActionRequestStatus["Failed"] = "Failed";
    MassActionRequestStatus["InProgress"] = "InProgress";
    MassActionRequestStatus["Initialized"] = "Initialized";
    MassActionRequestStatus["WaitingForConfirmation"] = "WaitingForConfirmation";
})(MassActionRequestStatus || (MassActionRequestStatus = {}));
export var MemberEmailStatus;
(function (MemberEmailStatus) {
    MemberEmailStatus["notDelivered"] = "notDelivered";
    MemberEmailStatus["sent"] = "sent";
    MemberEmailStatus["spammed"] = "spammed";
    MemberEmailStatus["verified"] = "verified";
})(MemberEmailStatus || (MemberEmailStatus = {}));
export var MemberInvitationFilterByOperator;
(function (MemberInvitationFilterByOperator) {
    MemberInvitationFilterByOperator["contains"] = "contains";
    MemberInvitationFilterByOperator["equals"] = "equals";
    MemberInvitationFilterByOperator["gt"] = "gt";
    MemberInvitationFilterByOperator["gte"] = "gte";
    MemberInvitationFilterByOperator["lt"] = "lt";
    MemberInvitationFilterByOperator["lte"] = "lte";
    MemberInvitationFilterByOperator["not"] = "not";
})(MemberInvitationFilterByOperator || (MemberInvitationFilterByOperator = {}));
export var MemberInvitationStatus;
(function (MemberInvitationStatus) {
    MemberInvitationStatus["Expired"] = "Expired";
    MemberInvitationStatus["Pending"] = "Pending";
    MemberInvitationStatus["Revoked"] = "Revoked";
    MemberInvitationStatus["accepted"] = "accepted";
    MemberInvitationStatus["delivered"] = "delivered";
    MemberInvitationStatus["notDelivered"] = "notDelivered";
    MemberInvitationStatus["notSent"] = "notSent";
    MemberInvitationStatus["rejected"] = "rejected";
    MemberInvitationStatus["sent"] = "sent";
    MemberInvitationStatus["spammed"] = "spammed";
})(MemberInvitationStatus || (MemberInvitationStatus = {}));
export var MemberListFilterByOperator;
(function (MemberListFilterByOperator) {
    MemberListFilterByOperator["contains"] = "contains";
    MemberListFilterByOperator["endsWith"] = "endsWith";
    MemberListFilterByOperator["equals"] = "equals";
    MemberListFilterByOperator["gt"] = "gt";
    MemberListFilterByOperator["gte"] = "gte";
    MemberListFilterByOperator["in"] = "in";
    MemberListFilterByOperator["lt"] = "lt";
    MemberListFilterByOperator["lte"] = "lte";
    MemberListFilterByOperator["nin"] = "nin";
    MemberListFilterByOperator["not"] = "not";
    MemberListFilterByOperator["startsWith"] = "startsWith";
})(MemberListFilterByOperator || (MemberListFilterByOperator = {}));
export var MemberStatus;
(function (MemberStatus) {
    MemberStatus["BLOCKED"] = "BLOCKED";
    MemberStatus["DELETED"] = "DELETED";
    MemberStatus["REMOVED"] = "REMOVED";
    MemberStatus["Suspended"] = "Suspended";
    MemberStatus["UNVERIFIED"] = "UNVERIFIED";
    MemberStatus["VERIFIED"] = "VERIFIED";
})(MemberStatus || (MemberStatus = {}));
export var MemberStatusInput;
(function (MemberStatusInput) {
    MemberStatusInput["BLOCKED"] = "BLOCKED";
    MemberStatusInput["Suspended"] = "Suspended";
    MemberStatusInput["UNVERIFIED"] = "UNVERIFIED";
    MemberStatusInput["VERIFIED"] = "VERIFIED";
})(MemberStatusInput || (MemberStatusInput = {}));
export var MigrationStage;
(function (MigrationStage) {
    MigrationStage["MEDIA"] = "MEDIA";
    MigrationStage["MEMBER"] = "MEMBER";
    MigrationStage["POST"] = "POST";
    MigrationStage["SPACE"] = "SPACE";
    MigrationStage["SPACE_MEMBER"] = "SPACE_MEMBER";
    MigrationStage["TAG"] = "TAG";
})(MigrationStage || (MigrationStage = {}));
export var MigrationStatus;
(function (MigrationStatus) {
    MigrationStatus["DONE"] = "DONE";
    MigrationStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(MigrationStatus || (MigrationStatus = {}));
export var ModerationEntityType;
(function (ModerationEntityType) {
    ModerationEntityType["MEMBER"] = "MEMBER";
    ModerationEntityType["POST"] = "POST";
})(ModerationEntityType || (ModerationEntityType = {}));
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["ACCEPTED"] = "ACCEPTED";
    ModerationStatus["REJECTED"] = "REJECTED";
    ModerationStatus["REVIEW"] = "REVIEW";
})(ModerationStatus || (ModerationStatus = {}));
export var NavigationItemType;
(function (NavigationItemType) {
    NavigationItemType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
    NavigationItemType["PRIMARY_LINK"] = "PRIMARY_LINK";
    NavigationItemType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
    NavigationItemType["TEXT_LINK"] = "TEXT_LINK";
})(NavigationItemType || (NavigationItemType = {}));
export var NetworkIndustryType;
(function (NetworkIndustryType) {
    NetworkIndustryType["BloggerCoachCreator"] = "BloggerCoachCreator";
    NetworkIndustryType["ConsultingAndAgency"] = "ConsultingAndAgency";
    NetworkIndustryType["EcomerceAndRetail"] = "EcomerceAndRetail";
    NetworkIndustryType["EntertainmentAndEvents"] = "EntertainmentAndEvents";
    NetworkIndustryType["FinancianServices"] = "FinancianServices";
    NetworkIndustryType["Healthcare"] = "Healthcare";
    NetworkIndustryType["InternetAndOnlineService"] = "InternetAndOnlineService";
    NetworkIndustryType["MediaAndPublishing"] = "MediaAndPublishing";
    NetworkIndustryType["NonProfitAndAssociation"] = "NonProfitAndAssociation";
    NetworkIndustryType["OnlineTrainingAndEducation"] = "OnlineTrainingAndEducation";
    NetworkIndustryType["Other"] = "Other";
    NetworkIndustryType["SoftwareAndSaas"] = "SoftwareAndSaas";
})(NetworkIndustryType || (NetworkIndustryType = {}));
export var NetworkLandingPage;
(function (NetworkLandingPage) {
    NetworkLandingPage["EXPLORE"] = "EXPLORE";
    NetworkLandingPage["FEED"] = "FEED";
    NetworkLandingPage["SPACES"] = "SPACES";
})(NetworkLandingPage || (NetworkLandingPage = {}));
export var NetworkMembership;
(function (NetworkMembership) {
    NetworkMembership["inviteOnly"] = "inviteOnly";
    NetworkMembership["open"] = "open";
})(NetworkMembership || (NetworkMembership = {}));
export var NetworkPasswordComplexity;
(function (NetworkPasswordComplexity) {
    NetworkPasswordComplexity["Complex"] = "Complex";
    NetworkPasswordComplexity["Simple"] = "Simple";
    NetworkPasswordComplexity["Standard"] = "Standard";
})(NetworkPasswordComplexity || (NetworkPasswordComplexity = {}));
export var NetworkPrimaryMembersType;
(function (NetworkPrimaryMembersType) {
    NetworkPrimaryMembersType["Customers"] = "Customers";
    NetworkPrimaryMembersType["Employees"] = "Employees";
    NetworkPrimaryMembersType["Members"] = "Members";
    NetworkPrimaryMembersType["Other"] = "Other";
    NetworkPrimaryMembersType["Students"] = "Students";
})(NetworkPrimaryMembersType || (NetworkPrimaryMembersType = {}));
export var NetworkReleaseChannelType;
(function (NetworkReleaseChannelType) {
    NetworkReleaseChannelType["edge"] = "edge";
    NetworkReleaseChannelType["stable"] = "stable";
})(NetworkReleaseChannelType || (NetworkReleaseChannelType = {}));
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus["archived"] = "archived";
    NetworkStatus["published"] = "published";
    NetworkStatus["unpublished"] = "unpublished";
})(NetworkStatus || (NetworkStatus = {}));
export var NetworkStatusChangedBy;
(function (NetworkStatusChangedBy) {
    NetworkStatusChangedBy["admin"] = "admin";
    NetworkStatusChangedBy["support"] = "support";
    NetworkStatusChangedBy["system"] = "system";
})(NetworkStatusChangedBy || (NetworkStatusChangedBy = {}));
export var NetworkStatusReason;
(function (NetworkStatusReason) {
    NetworkStatusReason["memberCapacityExceeded"] = "memberCapacityExceeded";
    NetworkStatusReason["networkCreated"] = "networkCreated";
    NetworkStatusReason["networkLockLifted"] = "networkLockLifted";
    NetworkStatusReason["seatsCapacityExceeded"] = "seatsCapacityExceeded";
    NetworkStatusReason["trialEnded"] = "trialEnded";
})(NetworkStatusReason || (NetworkStatusReason = {}));
export var NetworkTimeframeType;
(function (NetworkTimeframeType) {
    NetworkTimeframeType["FewMonths"] = "FewMonths";
    NetworkTimeframeType["FewWeeks"] = "FewWeeks";
    NetworkTimeframeType["NotSure"] = "NotSure";
    NetworkTimeframeType["VerySoon"] = "VerySoon";
})(NetworkTimeframeType || (NetworkTimeframeType = {}));
export var NetworkVisibility;
(function (NetworkVisibility) {
    NetworkVisibility["private"] = "private";
    NetworkVisibility["public"] = "public";
})(NetworkVisibility || (NetworkVisibility = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["DESKTOP"] = "DESKTOP";
    NotificationChannel["EMAIL"] = "EMAIL";
    NotificationChannel["IN_APP"] = "IN_APP";
})(NotificationChannel || (NotificationChannel = {}));
export var NotificationReason;
(function (NotificationReason) {
    NotificationReason["NETWORK_ADMIN"] = "NETWORK_ADMIN";
    NotificationReason["NETWORK_SUBSCRIPTION"] = "NETWORK_SUBSCRIPTION";
    NotificationReason["POST_AUTHOR"] = "POST_AUTHOR";
    NotificationReason["POST_SUBSCRIPTION"] = "POST_SUBSCRIPTION";
    NotificationReason["SPACE_ADMIN"] = "SPACE_ADMIN";
    NotificationReason["SPACE_SUBSCRIPTION"] = "SPACE_SUBSCRIPTION";
})(NotificationReason || (NotificationReason = {}));
export var NotificationVerb;
(function (NotificationVerb) {
    NotificationVerb["COMMENT_CREATED"] = "COMMENT_CREATED";
    NotificationVerb["COMMENT_DELETED"] = "COMMENT_DELETED";
    NotificationVerb["COMMENT_UPDATED"] = "COMMENT_UPDATED";
    NotificationVerb["JOIN_REQUEST_STATUS_UPDATED"] = "JOIN_REQUEST_STATUS_UPDATED";
    NotificationVerb["MEMBER_MENTIONED"] = "MEMBER_MENTIONED";
    NotificationVerb["POST_CREATED"] = "POST_CREATED";
    NotificationVerb["POST_DELETED"] = "POST_DELETED";
    NotificationVerb["POST_FOLLOWED"] = "POST_FOLLOWED";
    NotificationVerb["POST_UPDATED"] = "POST_UPDATED";
    NotificationVerb["REACTION_CREATED"] = "REACTION_CREATED";
    NotificationVerb["REPLY_CREATED"] = "REPLY_CREATED";
    NotificationVerb["SPACE_MEMBER_ADDED"] = "SPACE_MEMBER_ADDED";
})(NotificationVerb || (NotificationVerb = {}));
export var NumberTypeOptions;
(function (NumberTypeOptions) {
    NumberTypeOptions["integer"] = "integer";
    NumberTypeOptions["number"] = "number";
})(NumberTypeOptions || (NumberTypeOptions = {}));
export var PageSeoTagType;
(function (PageSeoTagType) {
    PageSeoTagType["LINK"] = "LINK";
    PageSeoTagType["META"] = "META";
    PageSeoTagType["TITLE"] = "TITLE";
})(PageSeoTagType || (PageSeoTagType = {}));
export var PayloadType;
(function (PayloadType) {
    PayloadType["JOIN_REQUEST_STATUS"] = "JOIN_REQUEST_STATUS";
    PayloadType["MEMBER"] = "MEMBER";
    PayloadType["NETWORK"] = "NETWORK";
    PayloadType["POST"] = "POST";
    PayloadType["REACTION"] = "REACTION";
    PayloadType["SPACE"] = "SPACE";
})(PayloadType || (PayloadType = {}));
export var PermissionContext;
(function (PermissionContext) {
    PermissionContext["MEMBER"] = "MEMBER";
    PermissionContext["NETWORK"] = "NETWORK";
    PermissionContext["POST"] = "POST";
    PermissionContext["SPACE"] = "SPACE";
})(PermissionContext || (PermissionContext = {}));
export var PinnedInto;
(function (PinnedInto) {
    PinnedInto["member"] = "member";
    PinnedInto["network"] = "network";
    PinnedInto["post"] = "post";
    PinnedInto["space"] = "space";
})(PinnedInto || (PinnedInto = {}));
export var PlanName;
(function (PlanName) {
    PlanName["Advanced"] = "Advanced";
    PlanName["Basic"] = "Basic";
    PlanName["Enterprise"] = "Enterprise";
    PlanName["Plus"] = "Plus";
    PlanName["PlusLegacy"] = "PlusLegacy";
    PlanName["Premium"] = "Premium";
    PlanName["PremiumLegacy"] = "PremiumLegacy";
    PlanName["basic"] = "basic";
    PlanName["enterprise"] = "enterprise";
    PlanName["plus"] = "plus";
    PlanName["premium"] = "premium";
})(PlanName || (PlanName = {}));
export var PlanRenewalType;
(function (PlanRenewalType) {
    PlanRenewalType["month"] = "month";
    PlanRenewalType["year"] = "year";
})(PlanRenewalType || (PlanRenewalType = {}));
export var PostFieldsEnum;
(function (PostFieldsEnum) {
    PostFieldsEnum["boolean1"] = "boolean1";
    PostFieldsEnum["boolean2"] = "boolean2";
    PostFieldsEnum["boolean3"] = "boolean3";
    PostFieldsEnum["boolean4"] = "boolean4";
    PostFieldsEnum["boolean5"] = "boolean5";
    PostFieldsEnum["date1"] = "date1";
    PostFieldsEnum["date2"] = "date2";
    PostFieldsEnum["date3"] = "date3";
    PostFieldsEnum["date4"] = "date4";
    PostFieldsEnum["date5"] = "date5";
    PostFieldsEnum["html1"] = "html1";
    PostFieldsEnum["html2"] = "html2";
    PostFieldsEnum["html3"] = "html3";
    PostFieldsEnum["html4"] = "html4";
    PostFieldsEnum["html5"] = "html5";
    PostFieldsEnum["html6"] = "html6";
    PostFieldsEnum["html7"] = "html7";
    PostFieldsEnum["html8"] = "html8";
    PostFieldsEnum["html9"] = "html9";
    PostFieldsEnum["html10"] = "html10";
    PostFieldsEnum["image1"] = "image1";
    PostFieldsEnum["image2"] = "image2";
    PostFieldsEnum["image3"] = "image3";
    PostFieldsEnum["image4"] = "image4";
    PostFieldsEnum["image5"] = "image5";
    PostFieldsEnum["number1"] = "number1";
    PostFieldsEnum["number2"] = "number2";
    PostFieldsEnum["number3"] = "number3";
    PostFieldsEnum["number4"] = "number4";
    PostFieldsEnum["number5"] = "number5";
    PostFieldsEnum["numberArray1"] = "numberArray1";
    PostFieldsEnum["numberArray2"] = "numberArray2";
    PostFieldsEnum["numberArray3"] = "numberArray3";
    PostFieldsEnum["numberArray4"] = "numberArray4";
    PostFieldsEnum["numberArray5"] = "numberArray5";
    PostFieldsEnum["text1"] = "text1";
    PostFieldsEnum["text2"] = "text2";
    PostFieldsEnum["text3"] = "text3";
    PostFieldsEnum["text4"] = "text4";
    PostFieldsEnum["text5"] = "text5";
    PostFieldsEnum["text6"] = "text6";
    PostFieldsEnum["text7"] = "text7";
    PostFieldsEnum["text8"] = "text8";
    PostFieldsEnum["text9"] = "text9";
    PostFieldsEnum["text10"] = "text10";
    PostFieldsEnum["textArray1"] = "textArray1";
    PostFieldsEnum["textArray2"] = "textArray2";
    PostFieldsEnum["textArray3"] = "textArray3";
    PostFieldsEnum["textArray4"] = "textArray4";
    PostFieldsEnum["textArray5"] = "textArray5";
})(PostFieldsEnum || (PostFieldsEnum = {}));
export var PostLastActivityEntityType;
(function (PostLastActivityEntityType) {
    PostLastActivityEntityType["Reaction"] = "Reaction";
    PostLastActivityEntityType["Reply"] = "Reply";
})(PostLastActivityEntityType || (PostLastActivityEntityType = {}));
export var PostListFilterByEnum;
(function (PostListFilterByEnum) {
    PostListFilterByEnum["boolean1"] = "boolean1";
    PostListFilterByEnum["boolean2"] = "boolean2";
    PostListFilterByEnum["boolean3"] = "boolean3";
    PostListFilterByEnum["boolean4"] = "boolean4";
    PostListFilterByEnum["boolean5"] = "boolean5";
    PostListFilterByEnum["createdAt"] = "createdAt";
    PostListFilterByEnum["date1"] = "date1";
    PostListFilterByEnum["date2"] = "date2";
    PostListFilterByEnum["date3"] = "date3";
    PostListFilterByEnum["date4"] = "date4";
    PostListFilterByEnum["date5"] = "date5";
    PostListFilterByEnum["number1"] = "number1";
    PostListFilterByEnum["number2"] = "number2";
    PostListFilterByEnum["number3"] = "number3";
    PostListFilterByEnum["number4"] = "number4";
    PostListFilterByEnum["number5"] = "number5";
    PostListFilterByEnum["publishedAt"] = "publishedAt";
    PostListFilterByEnum["updatedAt"] = "updatedAt";
})(PostListFilterByEnum || (PostListFilterByEnum = {}));
export var PostListFilterByOperator;
(function (PostListFilterByOperator) {
    PostListFilterByOperator["contains"] = "contains";
    PostListFilterByOperator["endsWith"] = "endsWith";
    PostListFilterByOperator["equals"] = "equals";
    PostListFilterByOperator["gt"] = "gt";
    PostListFilterByOperator["gte"] = "gte";
    PostListFilterByOperator["in"] = "in";
    PostListFilterByOperator["lt"] = "lt";
    PostListFilterByOperator["lte"] = "lte";
    PostListFilterByOperator["nin"] = "nin";
    PostListFilterByOperator["not"] = "not";
    PostListFilterByOperator["startsWith"] = "startsWith";
})(PostListFilterByOperator || (PostListFilterByOperator = {}));
export var PostListOrderByEnum;
(function (PostListOrderByEnum) {
    PostListOrderByEnum["boolean1"] = "boolean1";
    PostListOrderByEnum["boolean2"] = "boolean2";
    PostListOrderByEnum["boolean3"] = "boolean3";
    PostListOrderByEnum["boolean4"] = "boolean4";
    PostListOrderByEnum["boolean5"] = "boolean5";
    PostListOrderByEnum["createdAt"] = "createdAt";
    PostListOrderByEnum["date1"] = "date1";
    PostListOrderByEnum["date2"] = "date2";
    PostListOrderByEnum["date3"] = "date3";
    PostListOrderByEnum["date4"] = "date4";
    PostListOrderByEnum["date5"] = "date5";
    PostListOrderByEnum["lastActivityAt"] = "lastActivityAt";
    PostListOrderByEnum["negativeReactionsCount"] = "negativeReactionsCount";
    PostListOrderByEnum["number1"] = "number1";
    PostListOrderByEnum["number2"] = "number2";
    PostListOrderByEnum["number3"] = "number3";
    PostListOrderByEnum["number4"] = "number4";
    PostListOrderByEnum["number5"] = "number5";
    PostListOrderByEnum["positiveReactionsCount"] = "positiveReactionsCount";
    PostListOrderByEnum["publishedAt"] = "publishedAt";
    PostListOrderByEnum["reactionsCount"] = "reactionsCount";
    PostListOrderByEnum["repliesCount"] = "repliesCount";
    PostListOrderByEnum["text1"] = "text1";
    PostListOrderByEnum["text2"] = "text2";
    PostListOrderByEnum["text3"] = "text3";
    PostListOrderByEnum["text4"] = "text4";
    PostListOrderByEnum["text5"] = "text5";
    PostListOrderByEnum["totalRepliesCount"] = "totalRepliesCount";
    PostListOrderByEnum["updatedAt"] = "updatedAt";
})(PostListOrderByEnum || (PostListOrderByEnum = {}));
export var PostMappingTypeEnum;
(function (PostMappingTypeEnum) {
    PostMappingTypeEnum["boolean"] = "boolean";
    PostMappingTypeEnum["date"] = "date";
    PostMappingTypeEnum["html"] = "html";
    PostMappingTypeEnum["image"] = "image";
    PostMappingTypeEnum["number"] = "number";
    PostMappingTypeEnum["numberArray"] = "numberArray";
    PostMappingTypeEnum["text"] = "text";
    PostMappingTypeEnum["textArray"] = "textArray";
})(PostMappingTypeEnum || (PostMappingTypeEnum = {}));
export var PostStatus;
(function (PostStatus) {
    PostStatus["ARCHIVED"] = "ARCHIVED";
    PostStatus["BLOCKED"] = "BLOCKED";
    PostStatus["DELETED"] = "DELETED";
    PostStatus["DRAFTED"] = "DRAFTED";
    PostStatus["PUBLISHED"] = "PUBLISHED";
})(PostStatus || (PostStatus = {}));
export var PostTypeContext;
(function (PostTypeContext) {
    PostTypeContext["post"] = "post";
    PostTypeContext["reply"] = "reply";
})(PostTypeContext || (PostTypeContext = {}));
export var PrimaryScopes;
(function (PrimaryScopes) {
    PrimaryScopes["CreateContent"] = "CreateContent";
    PrimaryScopes["DeleteAuthMember"] = "DeleteAuthMember";
    PrimaryScopes["DeleteContent"] = "DeleteContent";
    PrimaryScopes["DeleteMember"] = "DeleteMember";
    PrimaryScopes["DeleteNetwork"] = "DeleteNetwork";
    PrimaryScopes["FindAuthMember"] = "FindAuthMember";
    PrimaryScopes["FindContent"] = "FindContent";
    PrimaryScopes["FindNetwork"] = "FindNetwork";
    PrimaryScopes["FullAccess"] = "FullAccess";
    PrimaryScopes["InviteMember"] = "InviteMember";
    PrimaryScopes["JoinNetwork"] = "JoinNetwork";
    PrimaryScopes["UpdateAuthMember"] = "UpdateAuthMember";
    PrimaryScopes["UpdateBilling"] = "UpdateBilling";
    PrimaryScopes["UpdateContent"] = "UpdateContent";
    PrimaryScopes["UpdateMember"] = "UpdateMember";
    PrimaryScopes["UpdateModeration"] = "UpdateModeration";
    PrimaryScopes["UpdateNetwork"] = "UpdateNetwork";
    PrimaryScopes["UpdateReport"] = "UpdateReport";
    PrimaryScopes["ViewAuthMember"] = "ViewAuthMember";
    PrimaryScopes["ViewContent"] = "ViewContent";
    PrimaryScopes["ViewMember"] = "ViewMember";
    PrimaryScopes["ViewNetwork"] = "ViewNetwork";
    PrimaryScopes["ViewReport"] = "ViewReport";
})(PrimaryScopes || (PrimaryScopes = {}));
export var ReactionType;
(function (ReactionType) {
    ReactionType["EMOJI_BASE"] = "EMOJI_BASE";
    ReactionType["LIKE_BASE"] = "LIKE_BASE";
    ReactionType["VOTE_BASE"] = "VOTE_BASE";
})(ReactionType || (ReactionType = {}));
export var RelationTypeOptions;
(function (RelationTypeOptions) {
    RelationTypeOptions["Media"] = "Media";
    RelationTypeOptions["Member"] = "Member";
    RelationTypeOptions["Post"] = "Post";
    RelationTypeOptions["Space"] = "Space";
    RelationTypeOptions["Tag"] = "Tag";
})(RelationTypeOptions || (RelationTypeOptions = {}));
export var ReportCategory;
(function (ReportCategory) {
    ReportCategory["HARASSMENT"] = "HARASSMENT";
    ReportCategory["MISINFORMATION"] = "MISINFORMATION";
    ReportCategory["NUDITY"] = "NUDITY";
    ReportCategory["SPAM"] = "SPAM";
    ReportCategory["SUICIDE"] = "SUICIDE";
    ReportCategory["TERRORISM"] = "TERRORISM";
    ReportCategory["VIOLENCE"] = "VIOLENCE";
})(ReportCategory || (ReportCategory = {}));
export var ReportDataType;
(function (ReportDataType) {
    ReportDataType["chartData"] = "chartData";
    ReportDataType["entityReport"] = "entityReport";
    ReportDataType["intValue"] = "intValue";
    ReportDataType["stringValue"] = "stringValue";
})(ReportDataType || (ReportDataType = {}));
export var ReportSlug;
(function (ReportSlug) {
    ReportSlug["activeMembers"] = "activeMembers";
    ReportSlug["averageDailyActiveMembers"] = "averageDailyActiveMembers";
    ReportSlug["highlights"] = "highlights";
    ReportSlug["memberScore"] = "memberScore";
    ReportSlug["newMembersOverTime"] = "newMembersOverTime";
    ReportSlug["newPosts"] = "newPosts";
    ReportSlug["newReactions"] = "newReactions";
    ReportSlug["newReplies"] = "newReplies";
    ReportSlug["popularDaysOfWeek"] = "popularDaysOfWeek";
    ReportSlug["popularHoursOfDay"] = "popularHoursOfDay";
    ReportSlug["postsVSreplies"] = "postsVSreplies";
    ReportSlug["topMembers"] = "topMembers";
    ReportSlug["topPosts"] = "topPosts";
    ReportSlug["topSpaces"] = "topSpaces";
    ReportSlug["totalMembers"] = "totalMembers";
    ReportSlug["totalPosts"] = "totalPosts";
    ReportSlug["totalReactions"] = "totalReactions";
    ReportSlug["totalReplies"] = "totalReplies";
    ReportSlug["totalVisitors"] = "totalVisitors";
    ReportSlug["trendingTags"] = "trendingTags";
})(ReportSlug || (ReportSlug = {}));
export var ReportTimeFrame;
(function (ReportTimeFrame) {
    ReportTimeFrame["allTime"] = "allTime";
    ReportTimeFrame["lastCalendarQuarter"] = "lastCalendarQuarter";
    ReportTimeFrame["lastCalendarYear"] = "lastCalendarYear";
    ReportTimeFrame["lastMonth"] = "lastMonth";
    ReportTimeFrame["lastNinetyDays"] = "lastNinetyDays";
    ReportTimeFrame["lastSevenDays"] = "lastSevenDays";
    ReportTimeFrame["lastThirtyDays"] = "lastThirtyDays";
    ReportTimeFrame["lastTwelveMonth"] = "lastTwelveMonth";
    ReportTimeFrame["lastWeek"] = "lastWeek";
    ReportTimeFrame["today"] = "today";
    ReportTimeFrame["yesterday"] = "yesterday";
})(ReportTimeFrame || (ReportTimeFrame = {}));
export var ReportableEntityType;
(function (ReportableEntityType) {
    ReportableEntityType["member"] = "member";
    ReportableEntityType["post"] = "post";
    ReportableEntityType["space"] = "space";
    ReportableEntityType["topic"] = "topic";
})(ReportableEntityType || (ReportableEntityType = {}));
export var RichTextTypeOptions;
(function (RichTextTypeOptions) {
    RichTextTypeOptions["html"] = "html";
    RichTextTypeOptions["markup"] = "markup";
})(RichTextTypeOptions || (RichTextTypeOptions = {}));
export var RoleListOrderByEnum;
(function (RoleListOrderByEnum) {
    RoleListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    RoleListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(RoleListOrderByEnum || (RoleListOrderByEnum = {}));
export var RoleType;
(function (RoleType) {
    RoleType["admin"] = "admin";
    RoleType["guest"] = "guest";
    RoleType["member"] = "member";
    RoleType["moderator"] = "moderator";
})(RoleType || (RoleType = {}));
export var SearchEntityType;
(function (SearchEntityType) {
    SearchEntityType["External"] = "External";
    SearchEntityType["member"] = "member";
    SearchEntityType["post"] = "post";
    SearchEntityType["space"] = "space";
})(SearchEntityType || (SearchEntityType = {}));
export var ShortContentFormat;
(function (ShortContentFormat) {
    ShortContentFormat["Html"] = "Html";
    ShortContentFormat["Text"] = "Text";
})(ShortContentFormat || (ShortContentFormat = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SpaceJoinRequestStatus;
(function (SpaceJoinRequestStatus) {
    SpaceJoinRequestStatus["COMPLETED"] = "COMPLETED";
    SpaceJoinRequestStatus["DECLINED"] = "DECLINED";
    SpaceJoinRequestStatus["PENDING"] = "PENDING";
})(SpaceJoinRequestStatus || (SpaceJoinRequestStatus = {}));
export var SpaceListOrderByEnum;
(function (SpaceListOrderByEnum) {
    SpaceListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    SpaceListOrderByEnum["CUSTOM_ORDERING_INDEX"] = "CUSTOM_ORDERING_INDEX";
    SpaceListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(SpaceListOrderByEnum || (SpaceListOrderByEnum = {}));
export var SpaceMemberListOrderByEnum;
(function (SpaceMemberListOrderByEnum) {
    SpaceMemberListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    SpaceMemberListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(SpaceMemberListOrderByEnum || (SpaceMemberListOrderByEnum = {}));
export var SpaceMembershipStatus;
(function (SpaceMembershipStatus) {
    SpaceMembershipStatus["Archived"] = "Archived";
    SpaceMembershipStatus["Closed"] = "Closed";
    SpaceMembershipStatus["joined"] = "joined";
    SpaceMembershipStatus["notJoined"] = "notJoined";
    SpaceMembershipStatus["requested"] = "requested";
})(SpaceMembershipStatus || (SpaceMembershipStatus = {}));
export var SpaceNotificationPreference;
(function (SpaceNotificationPreference) {
    SpaceNotificationPreference["ALL"] = "ALL";
    SpaceNotificationPreference["NEW_POST"] = "NEW_POST";
    SpaceNotificationPreference["NONE"] = "NONE";
})(SpaceNotificationPreference || (SpaceNotificationPreference = {}));
export var SpaceRoleListOrderByEnum;
(function (SpaceRoleListOrderByEnum) {
    SpaceRoleListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    SpaceRoleListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(SpaceRoleListOrderByEnum || (SpaceRoleListOrderByEnum = {}));
export var SpaceRoleType;
(function (SpaceRoleType) {
    SpaceRoleType["admin"] = "admin";
    SpaceRoleType["member"] = "member";
})(SpaceRoleType || (SpaceRoleType = {}));
export var SpaceType;
(function (SpaceType) {
    SpaceType["Broadcast"] = "Broadcast";
    SpaceType["Entity"] = "Entity";
    SpaceType["Group"] = "Group";
    SpaceType["Page"] = "Page";
    SpaceType["PrivateMessage"] = "PrivateMessage";
})(SpaceType || (SpaceType = {}));
export var SsoProvider;
(function (SsoProvider) {
    SsoProvider["auth0"] = "auth0";
    SsoProvider["custom"] = "custom";
    SsoProvider["memberful"] = "memberful";
    SsoProvider["okta"] = "okta";
    SsoProvider["outseta"] = "outseta";
    SsoProvider["wordpress"] = "wordpress";
})(SsoProvider || (SsoProvider = {}));
export var SsoStatus;
(function (SsoStatus) {
    SsoStatus["disable"] = "disable";
    SsoStatus["enable"] = "enable";
})(SsoStatus || (SsoStatus = {}));
export var SsoType;
(function (SsoType) {
    SsoType["Apple"] = "Apple";
    SsoType["Discord"] = "Discord";
    SsoType["Saml"] = "Saml";
    SsoType["Slack"] = "Slack";
    SsoType["Twitter"] = "Twitter";
    SsoType["facebook"] = "facebook";
    SsoType["google"] = "google";
    SsoType["jwt"] = "jwt";
    SsoType["linkedin"] = "linkedin";
    SsoType["oauth2"] = "oauth2";
})(SsoType || (SsoType = {}));
export var StoreItemStanding;
(function (StoreItemStanding) {
    StoreItemStanding["OFFICIAL"] = "OFFICIAL";
    StoreItemStanding["REGULAR"] = "REGULAR";
    StoreItemStanding["VERIFIED"] = "VERIFIED";
})(StoreItemStanding || (StoreItemStanding = {}));
export var StoreItemStatus;
(function (StoreItemStatus) {
    StoreItemStatus["DELETED"] = "DELETED";
    StoreItemStatus["PRIVATE"] = "PRIVATE";
    StoreItemStatus["PUBLIC"] = "PUBLIC";
})(StoreItemStatus || (StoreItemStatus = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["active"] = "active";
    SubscriptionStatus["canceled"] = "canceled";
    SubscriptionStatus["failed"] = "failed";
    SubscriptionStatus["incomplete"] = "incomplete";
    SubscriptionStatus["incomplete_expired"] = "incomplete_expired";
    SubscriptionStatus["past_due"] = "past_due";
    SubscriptionStatus["trialing"] = "trialing";
    SubscriptionStatus["unpaid"] = "unpaid";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var TagFilterType;
(function (TagFilterType) {
    TagFilterType["BLACKLIST"] = "BLACKLIST";
    TagFilterType["WHITELIST"] = "WHITELIST";
})(TagFilterType || (TagFilterType = {}));
export var TagListOrderByEnum;
(function (TagListOrderByEnum) {
    TagListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    TagListOrderByEnum["ID"] = "ID";
    TagListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(TagListOrderByEnum || (TagListOrderByEnum = {}));
export var TagsOrderByEnum;
(function (TagsOrderByEnum) {
    TagsOrderByEnum["CREATED_AT"] = "CREATED_AT";
    TagsOrderByEnum["ID"] = "ID";
    TagsOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(TagsOrderByEnum || (TagsOrderByEnum = {}));
export var TemplateEntityType;
(function (TemplateEntityType) {
    TemplateEntityType["Post"] = "Post";
    TemplateEntityType["PostType"] = "PostType";
    TemplateEntityType["Space"] = "Space";
    TemplateEntityType["SpacePostType"] = "SpacePostType";
    TemplateEntityType["Tag"] = "Tag";
})(TemplateEntityType || (TemplateEntityType = {}));
export var TemplateRequestStatus;
(function (TemplateRequestStatus) {
    TemplateRequestStatus["Failed"] = "Failed";
    TemplateRequestStatus["InProgress"] = "InProgress";
    TemplateRequestStatus["Succeeded"] = "Succeeded";
})(TemplateRequestStatus || (TemplateRequestStatus = {}));
export var TextTypeOptions;
(function (TextTypeOptions) {
    TextTypeOptions["fullText"] = "fullText";
    TextTypeOptions["shortText"] = "shortText";
})(TextTypeOptions || (TextTypeOptions = {}));
export var ThemeStatus;
(function (ThemeStatus) {
    ThemeStatus["draft"] = "draft";
    ThemeStatus["published"] = "published";
})(ThemeStatus || (ThemeStatus = {}));
export var ToastStatus;
(function (ToastStatus) {
    ToastStatus["Error"] = "Error";
    ToastStatus["Info"] = "Info";
    ToastStatus["Neutral"] = "Neutral";
    ToastStatus["Success"] = "Success";
    ToastStatus["Warning"] = "Warning";
})(ToastStatus || (ToastStatus = {}));
export var TopNavigationAlignment;
(function (TopNavigationAlignment) {
    TopNavigationAlignment["CENTER"] = "CENTER";
    TopNavigationAlignment["LEFT"] = "LEFT";
    TopNavigationAlignment["RIGHT"] = "RIGHT";
})(TopNavigationAlignment || (TopNavigationAlignment = {}));
export var TranslationMarkupFormat;
(function (TranslationMarkupFormat) {
    TranslationMarkupFormat["HTML"] = "HTML";
    TranslationMarkupFormat["TEXT"] = "TEXT";
})(TranslationMarkupFormat || (TranslationMarkupFormat = {}));
export var UnauthorizedReason;
(function (UnauthorizedReason) {
    UnauthorizedReason["ACCESS"] = "ACCESS";
    UnauthorizedReason["PLAN"] = "PLAN";
})(UnauthorizedReason || (UnauthorizedReason = {}));
export var UnsubscribeTokenContext;
(function (UnsubscribeTokenContext) {
    UnsubscribeTokenContext["ALL"] = "ALL";
    UnsubscribeTokenContext["MEMBER"] = "MEMBER";
    UnsubscribeTokenContext["MENTIONS"] = "MENTIONS";
    UnsubscribeTokenContext["POST"] = "POST";
    UnsubscribeTokenContext["REACTIONS"] = "REACTIONS";
    UnsubscribeTokenContext["SPACE"] = "SPACE";
})(UnsubscribeTokenContext || (UnsubscribeTokenContext = {}));
export var VatType;
(function (VatType) {
    VatType["ae_trn"] = "ae_trn";
    VatType["au_abn"] = "au_abn";
    VatType["au_arn"] = "au_arn";
    VatType["br_cnpj"] = "br_cnpj";
    VatType["br_cpf"] = "br_cpf";
    VatType["ca_bn"] = "ca_bn";
    VatType["ca_gst_hst"] = "ca_gst_hst";
    VatType["ca_pst_bc"] = "ca_pst_bc";
    VatType["ca_pst_mb"] = "ca_pst_mb";
    VatType["ca_pst_sk"] = "ca_pst_sk";
    VatType["ca_qst"] = "ca_qst";
    VatType["ch_vat"] = "ch_vat";
    VatType["cl_tin"] = "cl_tin";
    VatType["es_cif"] = "es_cif";
    VatType["eu_vat"] = "eu_vat";
    VatType["gb_vat"] = "gb_vat";
    VatType["hk_br"] = "hk_br";
    VatType["id_npwp"] = "id_npwp";
    VatType["il_vat"] = "il_vat";
    VatType["in_gst"] = "in_gst";
    VatType["jp_cn"] = "jp_cn";
    VatType["jp_rn"] = "jp_rn";
    VatType["kr_brn"] = "kr_brn";
    VatType["li_uid"] = "li_uid";
    VatType["mx_rfc"] = "mx_rfc";
    VatType["my_frp"] = "my_frp";
    VatType["my_itn"] = "my_itn";
    VatType["my_sst"] = "my_sst";
    VatType["no_vat"] = "no_vat";
    VatType["nz_gst"] = "nz_gst";
    VatType["ru_inn"] = "ru_inn";
    VatType["ru_kpp"] = "ru_kpp";
    VatType["sa_vat"] = "sa_vat";
    VatType["sg_gst"] = "sg_gst";
    VatType["sg_uen"] = "sg_uen";
    VatType["th_vat"] = "th_vat";
    VatType["tw_vat"] = "tw_vat";
    VatType["us_ein"] = "us_ein";
    VatType["za_vat"] = "za_vat";
})(VatType || (VatType = {}));
const result = {
    possibleTypes: {
        By: ['Member'],
        In: ['Space'],
        Media: ['Emoji', 'File', 'Image'],
        ModerationItemEntity: ['Member', 'Post'],
        PageEntity: ['Collection', 'Member', 'Post'],
        PostLastActivityEntity: ['Post', 'PostReactionParticipant'],
        ReportDataValue: ['ChartData', 'EntityReport', 'IntValue', 'StringValue'],
        ReportableEntity: ['Member', 'Post', 'Space', 'Tag'],
        TemplateCreatedEntity: ['Space'],
    },
};
export default result;
//# sourceMappingURL=tribe-graphql.generated.js.map